import { handleActions } from 'redux-actions';
import * as R from 'ramda';

import {
  FETCH_COMPANIES,
  FETCH_COMPANY,
  UPDATE_COMPANY,
  COMPANIES_FILTER_SET,
  COMPANIES_PAGE_SET,
  CURRENT_COMPANY_RESET
} from '../../constants/Constants';

const initialState = { items: [], filter: null, currentCompany: {}, pagination: { page: 0, size: 50 } };

const COLLATOR = new Intl.Collator('cs');
const nameComparator = (a, b) => COLLATOR.compare(a.name, b.name);

export default handleActions(
  {
    [FETCH_COMPANIES.SUCCESS]: (state, { payload: { items } }) => ({
      ...state,
      items: R.sortWith([nameComparator])(items)
    }),
    [FETCH_COMPANY.SUCCESS]: (state, { payload: { payload } }) => ({ ...state, currentCompany: payload }),
    [UPDATE_COMPANY.SUCCESS]: (state, { payload: { payload } }) => ({
      ...state,
      currentCompany: payload,
      currentCompanySaving: false
    }),
    [UPDATE_COMPANY.PENDING]: state => ({ ...state, currentCompanySaving: true }),
    [COMPANIES_FILTER_SET]: (state, { payload }) => ({ ...state, filter: payload }),
    [COMPANIES_PAGE_SET]: (state, { payload: { page } }) => ({ ...state, pagination: { ...state.pagination, page } }),
    [CURRENT_COMPANY_RESET]: state => ({ ...state, currentCompany: {} })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/entities/CompaniesReducer.js